module.exports = {
  "country": "AZ",
  "artist": "Chingiz",
  "song": "Truth",
  "year": "2019",
  "place": "8",
  "spotify": ""
};